import { BASE_URL } from "@constants/api.constants";
import { menuItemsAutoCompleteAPI } from "@screens/system/menu-items/menu-items-list/menu-items-list.component.service";
import { uploadImageFile } from "@utils/upload.util";

export const getSettingFormInputs = (initialValues) => [
  {
    type: "TEXT",
    label: "Setting Name",
    id: "setting_name",
    name: "setting_name",
    // isDisabled: true,
    value: initialValues?.setting_name || "",
    placeholder: "Enter the setting name",
    validations: [
      {
        type: "REQUIRED",
        message: "Setting name is required !",
      },
    ],
  },

  {
    type: "TEXT",
    label: "Setting Value",
    id: "setting_name",
    name: "setting_value",
    value: initialValues?.setting_value || "",
    placeholder: "Enter the setting value",
    validations: [
      {
        type: "REQUIRED",
        message: "Setting value is required !",
      },
    ],
  },
];
